// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_NO_MORE_PRODUCTS = "Zvolen\u00fdm filtrom nezodpoved\u00e1 \u017eiaden inzer\u00e1t";
